import { Component } from '@angular/core';

@Component({
    selector: 'app-kb-warranty-landing-page',
    templateUrl: './kb-warranty-landing-page.component.html',
    styleUrls: ['./kb-warranty-landing-page.component.scss'],
    standalone: false
})
export class KbWarrantyLandingPageComponent {

}
